import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

// import { getIDData } from "../_api/enrolleeApi";

import { makeStyles, withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import UploadIcon from "@mui/icons-material/Upload";
import InfoIcon from "@mui/icons-material/Info";
import { SaveLoader } from "@/_components";
import { saveProfile } from "../_redux/actions/profileActions";
import { getProfile } from "../_api/profileApi";
// import { LifeSafer } from "../_helpers/BrandConstants";
import PhotoTake from "./PhotoTake";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PhotoManagement = ({ setValidIdSubmit, validatedData }) => {
  const { t } = useTranslation();
  // const { token } = useParams();
  // const cookies = new Cookies();
  // const user = cookies.get("lifesaferUser");
  // const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const [value, setValue] = useState(0);
  const [imageData, setImageData] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  // const [profileInfo, setProfileInfo] = useState(null);
  const [file, setFile] = useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // console.log(user);
  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let imageFile = event.target.files[0];
      const reader = new FileReader();

      if (event.target.files[0].type.slice(0, 6) === "image/") {
        reader.onload = (x) => {
          setFile({
            imageFile: imageFile,
            imageSrc: x.target.result,
          });
        };
        reader.readAsDataURL(imageFile);
      } else {
        setFile({
          imageFile: imageFile,
          imageSrc: "",
        });
      }
    } else {
      setFile();
    }
  };

  // const uploadClick = (uploadType) => {
  //   setSubmitting(true);

  //   const fileUpload =
  //     uploadType === "Photo" ? imageData.imageFile : file.imageFile;

  //   const formData = new FormData();
  //   formData.append("uploadFile", fileUpload);

  //   const userId = validatedData?.userID;
  //   const token = validatedData?.jwtToken;

  //   const url = `${process.env.API_URL}/BarCodeReader/ReadDriverLicense?userId=${userId}`;

  //   fetch(url, {
  //     method: "POST",
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //     },
  //     body: formData,
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Network response was not ok");
  //       }
  //       return response.json();
  //     })
  //     .then((resultSet) => {
  //       //call get users/id api

  //       console.log("Barcode Reader Success:", resultSet);
  //       if (resultSet?.id === null) {
  //         toast.error("Invalid Data. Please try again.");
  //         badCall();
  //       } else {
  //         //call get client Api
  //         // loadProfile(validatedData.clientID)
  //           getProfile(validatedData.clientID)
  //             .then((clientData) => {
  //               setProfileInfo(clientData[0]);
  //             })
  //             .catch((error) => {
  //               console.error("Error getting client data : ", error);
  //           });
  //           console.log("Profile Info:", profileInfo);

  //            const initialProfile = {
  //             cellPhone: profileInfo.cellPhone,
  //             city: profileInfo.city,
  //             clientID: profileInfo.clientID,
  //             contactFirstName: profileInfo.contactFirstName,
  //             contactID: profileInfo.contactID,
  //             contactLastName: profileInfo.contactLastName,
  //             contactPhone: profileInfo.contactPhone,
  //             dlExpirationDate: profileInfo.dlExpirationDate,
  //             dlNum: resultSet?.id,
  //             dlState: profileInfo.dlState,
  //             dob: profileInfo.dob,
  //             email: profileInfo.email,
  //             emailContact: profileInfo.emailContact,
  //             firstName: profileInfo.firstName,
  //             homeAddr1: profileInfo.homeAddr1,
  //             homeAddr2: profileInfo.homeAddr2,
  //             homePhone: profileInfo.homePhone,
  //             jurisdictionID: validatedData.jurisdictionID,
  //             languageID: profileInfo.languageID,
  //             lastName: profileInfo.lastName,
  //             county: profileInfo.county,
  //             state: profileInfo.state,
  //             country: profileInfo.country,
  //             textContact: profileInfo.textContact,
  //             userId: validatedData?.userID,
  //             zip: profileInfo.zip,
  //           };

  //           // let data = {
  //           //   firstName: resultSet?.firstName,
  //           //   lastName: resultSet?.lastName,
  //           //   dob: resultSet?.dob,
  //           //   homeAddr1: resultSet?.streetAddress,
  //           //   homeAddr2: "",
  //           //   city: resultSet?.city,
  //           //   zip: resultSet?.zipCode.substring(0, 5),
  //           //   state: resultSet?.state,
  //           //   county: "",
  //           //   country: resultSet?.country,
  //           //   dlState: resultSet?.state,
  //           //   dlNum: resultSet?.id,
  //           //   dlExpirationDate: resultSet?.expiryDate,
  //           // };
  //         //Dont Know the response of barcode liscence image so data consoling to check
  //         console.log(initialProfile);
  //         if (initialProfile) {
  //           saveProfile(validatedData.clientID,initialProfile)
  //             .then(() => {
  //               setSubmitting(false);
  //               setValidIdSubmit(true);
  //               toast.success(t("toasts.updateComplete"));
  //             })
  //             .catch((error) => {
  //               console.log("Update failed. " + error);
  //               toast.success(t("toasts.updateFailed") + " " + error);
  //               setSubmitting(false);
  //             });
  //         }
  //       }
  //       setSubmitting(false);
  //     })
  //     .catch((error) => {
  //       console.error("Barcode Reader Failed:", error);
  //       // toast.error(error.message || "Something went wrong");
  //       badCall();
  //       setValidIdSubmit(false);
  //       setSubmitting(false);
  //     });
  // };

  const uploadClick = async (uploadType) => {
    setSubmitting(true);

    const fileUpload =
      uploadType === "Photo" ? imageData.imageFile : file.imageFile;

    const formData = new FormData();
    formData.append("uploadFile", fileUpload);

    const userId = validatedData?.userID;
    const token = validatedData?.jwtToken;

    const url = `${process.env.API_URL}/BarCodeReader/ReadDriverLicense?userId=${userId}`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const resultSet = await response.json();
      // console.log("Barcode Reader Success:", resultSet);

      if (resultSet?.id === null) {
        toast.error("Invalid Data. Please try again.");
        badCall();
        return;
      }

      // Get client data
      try {
        const clientData = await getProfile(validatedData.clientID);
        // console.log("Client Data:", clientData);
        const initialProfile = {
          cellPhone: clientData[0].cellPhone,
          city: clientData[0].city,
          clientID: clientData[0].clientID,
          contactFirstName: clientData[0].contactFirstName,
          contactID: clientData[0].contactID,
          contactLastName: clientData[0].contactLastName,
          contactPhone: clientData[0].contactPhone,
          dlExpirationDate: clientData[0].dlExpirationDate,
          dlNum: resultSet?.id,//update
          dlState: resultSet.state,//update
          dob: clientData[0].dob,
          email: clientData[0].email,
          emailContact: clientData[0].emailContact,
          firstName: clientData[0].firstName,
          homeAddr1: clientData[0].homeAddr1,
          homeAddr2: clientData[0].homeAddr2,
          homePhone: clientData[0].homePhone,
          jurisdictionID: validatedData.jurisdictionID,
          languageID: clientData[0].languageID,
          lastName: clientData[0].lastName,
          county: clientData[0].county,
          state: clientData[0].state,
          country: clientData[0].country,
          textContact: clientData[0].textContact,
          userId: validatedData?.userID,
          zip: clientData[0].zip,
        };

        if (initialProfile) {
          try {
            await saveProfile(validatedData.clientID, initialProfile);
            setValidIdSubmit(true);
            toast.success(t("toasts.updateComplete"));
          } catch (error) {
            console.error("Update failed: ", error);
            toast.error(t("toasts.updateFailed") + " " + error);
          }
        }
      } catch (error) {
        console.error("Error getting client data: ", error);
      }
    } catch (error) {
      console.error("Barcode Reader Failed:", error);
      badCall();
      setValidIdSubmit(false);
    } finally {
      setSubmitting(false);
    }
  };

  const badCall = () => {
    setImageData(null);
    setFile(null);
    setSubmitting(false);
  };
   
  const InstructionHeader = () => {
    return (
      <Grid container direction="row" justifyContent="center" mt={1}>
        <Grid item>
          <Typography style={{ fontWeight: 600, fontSize: 18 }}>
            {t("registration.instructions")}:
          </Typography>
        </Grid>
        <Grid item style={{ marginLeft: -4, marginTop: -14 }}>
          <Tooltip
            placement="top"
            leaveTouchDelay={3000}
            enterTouchDelay={50}
            open={showTooltip}
            onOpen={() => setShowTooltip(true)}
            onClose={() => setShowTooltip(false)}
            title={
              <>
                <img
                  className={classes.tooltipPic}
                  src={"./src/_images/Empty_License_Template.png"}
                />
              </>
            }
          >
            <IconButton
              aria-label="info"
              onClick={() => setShowTooltip(!showTooltip)}
              size="large"
              sx={{ marginTop: "4px !important", }}
            >
              <InfoIcon  />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    );
  };

  const StyledTabs = withStyles({
    root: { borderBottom: "1px solid #e8e8e8", borderTop: "1px solid #e8e8e8" },
    indicator: { backgroundColor: "#76bc21" },
  })(Tabs);

  const StyledTab = withStyles(() => ({
    root: {
      textTransform: "none", //This removes the all caps default state
      width: 160,
      fontWeight: 400,
      "&$selected": {
        color: "#76bc21",
        fontWeight: 600,
      },
    },
    selected: {},
  }))((props) => <Tab {...props} />);
  const useStyles = makeStyles({
    labelToBtn: {
      backgroundColor: "#1c355e",
      color: "#fff",
      cursor: "pointer",
      outline: 0,
      border: 0,
      margin: 0,
      justifyContent: "center",
      verticalAlign: "middle",
      font: "400 13.3333px Arial",
      lineHeight: 1.75,
      letterSpacing: "0.02857em",
      textTransform: "uppercase",
      padding: "10px 16px",
      borderRadius: 4,
      "&:hover": {
        backgroundColor: "#1c355e",
        boxShadow:
          "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
      },
    },
    chooselabelToBtn: {
      backgroundColor: "#1c355e",
      color: "#fff",
      cursor: "pointer",
      outline: 0,
      border: 0,
      margin: 0,
      justifyContent: "center",
      verticalAlign: "middle",
      font: "400 13.3333px Arial",
      lineHeight: 1.75,
      letterSpacing: "0.02857em",
      textTransform: "uppercase",
      padding: "10px 16px",
      borderRadius: 4,
      "&:hover": {
        backgroundColor: "#1c355e",
        boxShadow:
          "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
      },
    },
    tooltipPic: {
      width: 240,
      height: 240,
    },
  });
  const classes = useStyles();
  return (
    <>
      <div className={classes.tabBar}>
        <StyledTabs value={value} onChange={handleChange}>
          <StyledTab
            label={
              <div style={{ display: "inline-block" }}>
                <div style={{ display: "inline" }}>
                  {t("registration.takePhoto")}
                </div>
              </div>
            }
            icon={<AddAPhotoIcon />}
            {...a11yProps(0)}
          />
          <StyledTab
            label={
              <div style={{ display: "inline-block" }}>
                <div style={{ display: "inline" }}>
                  {t("registration.uploadPhoto")}
                </div>
              </div>
            }
            icon={<AddPhotoAlternateIcon />}
            {...a11yProps(1)}
          />
        </StyledTabs>
      </div>
      <div>
        <TabPanel value={value} index={0}>
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <div className="fds" style={{ maxWidth: 320 }}>
              {imageData ? (
                <Grid item>
                  <img
                    src={imageData.imageSrc}
                    alt="Picture"
                    style={{ height: "100%", width: "100%" }}
                  />
                </Grid>
              ) : (
                <>
                  <Grid item style={{ paddingTop: 5, paddingBottom: 5 }}>
                    <InstructionHeader />
                  </Grid>
                  <Grid item>
                    <Typography>{t("registration.takePhotoDesp")}</Typography>
                  </Grid>
                </>
              )}
              {imageData ? (
                <Grid item>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    style={{ paddingTop: 10 }}
                  >
                    <Grid item style={{ paddingRight: 15 }}>
                      <Button
                        disabled={submitting}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={() => setImageData(null)}
                        startIcon={
                          <RotateLeftIcon style={{ fontSize: "1.4em" }} />
                        }
                      >
                        {t("registration.retake")}
                      </Button>
                    </Grid>
                    <Grid item style={{ paddingLeft: 15 }}>
                      <Button
                        disabled={submitting}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={() => uploadClick("Photo")}
                        startIcon={<UploadIcon style={{ fontSize: "1.4em" }} />}
                      >
                        {t("registration.upload")}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  item
                  style={{
                    paddingTop: 20,
                    paddingBottom: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxWidth: 320,
                  }}
                >
                  <PhotoTake
                    setImageData={setImageData}
                    imageData={imageData}
                    uploadClick={uploadClick}
                    submitting={submitting}
                  />
                </Grid>
              )}
            </div>
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ maxWidth: 320 }}
          >
            {file ? (
              <Grid item>
                <img
                  src={file.imageSrc}
                  alt={t("registration.badPhotoFile")}
                  style={{ height: "100%", width: "100%" }}
                />
              </Grid>
            ) : (
              <>
                <Grid item style={{ paddingTop: 5, paddingBottom: 5 }}>
                  <InstructionHeader />
                </Grid>
                <Grid item>
                  <Typography>{t("registration.uploadPhotoDesp")}</Typography>
                </Grid>
              </>
            )}
            {file ? (
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  style={{ paddingTop: 10 }}
                >
                  <Grid item style={{ paddingRight: 15 }}>
                    <Button
                      disabled={submitting}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={() => setFile(null)}
                      startIcon={
                        <RotateLeftIcon style={{ fontSize: "1.4em" }} />
                      }
                    >
                      {t("registration.newFile")}
                    </Button>
                  </Grid>
                  <Grid item style={{ paddingLeft: 15 }}>
                    {submitting === false ? (
                      <Button
                        disabled={submitting || file === null}
                        size="medium"
                        variant="contained"
                        color="primary"
                        onClick={() => uploadClick("File")}
                        startIcon={<UploadIcon style={{ fontSize: "1.4em" }} />}
                      >
                        {t("registration.upload")}
                      </Button>
                    ) : (
                      <SaveLoader />
                    )}
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <Grid item style={{ paddingTop: 20, paddingBottom: 10 }}>
                <input
                  id="actual-btn"
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleFileChange}
                />
                <label className={classes.labelToBtn} htmlFor="actual-btn">
                  {t("registration.chooseFile")}
                </label>
              </Grid>
            )}
          </Grid>
        </TabPanel>
      </div>
    </>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

PhotoManagement.propTypes = {
  submitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
  setStep: PropTypes.func,
  setInvalidUpload: PropTypes.func,
  setValidIdSubmit: PropTypes.func,
  validatedData: PropTypes.object,
};

function mapStateToProps() {
  return {
    // enrollee: state.enrollee
  };
}

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PhotoManagement);
